import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const { isLoggedIn, access_token } = useSelector((state) => state.auth);
  const location = useLocation();

  if (!isLoggedIn || !access_token) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  return children;
};

export default PrivateRoute;
